module.exports = __webpack_public_path__ + "img/handraw_bulle d'aide blanc.67e530e4.svg";